import { combineReducers } from "redux";
import locale from "./Lang/reducer";
import snackbar from "./Snackbar/reducer";
import loader from "./Loader/reducer";
import navigation from "./Navigation/reducer";
import lookups from "./Lookups/reducer";
import auth from "./Auth/reducer";
import events from "./Events/reducer";
import routing from "./Routing/reducers";
import requests from "./Requests/reducer";
import employees from "./Employees/reducer";
import applicants from "./applicants/reducer";
import promotionRequests from "./PromotionRequests/reducer";
import companiesRegistration from "./RegistrationReq/reducer";
import companiesList from "./CompaniesList/reducer";
import profileEditRequests from "./ProfileEditRequests/reducer";
import notifications from "./Notifications/reducer";
import timesheet from "./TimeSheet/reducer";
import applicantsTimeSheetRequest from "./ApplicantsTimeSheet/reducer";
import trainingWorkingSlots from "./TrainingWorkingSlots/reducer";
import evaluations from "./Evaluations/reducer";
import locations from "./Locations/reducer";
import note from "./Notes/reducer";
import _filters from "./Filter/reducer";
import reason from "./Reasons/reducers";
import report from "./Reports/reducer";
import joiningRequest from "./JoiningRequest/reducer";
import applicantTabs from "./ApplicantsTab/reducer";
import persistEmployee from "./PersistEmployees/reducer";
import persistTimeSheet from "./PersistTimeSheet/reducer";
import persistTimeSheetEvent from "./PersistTimeSheetEvent/reducer";
import role from "./Role/reducer";
import persistReport from "./PersistReport/reducer";
import clientsReducer from "./clients/reducer";
import surveyReducer from "./Survey/reducer";
import heatmapReducer from "./HeatMap/reducer";
import rolesReducer from "./Roles/reducers";
import applicantReports from "./ApplicantReports/reducer";
import applicantTabExportSheet from "./ApplicantTabExportSheet/reducer";
import companyEditRequest from "./CompanyPortal/Settings/EditProfile/reducer";
import companyMyCompany from "./CompanyPortal/MyCompany/reducer";
import companyEventRequests from "./CompanyPortal/EventRequests/reducer";
import companyRoles from "./CompanyPortal/Roles/reducer";
import companyEmployees from "./CompanyPortal/Employees/reducer";
import companyClients from "./CompanyPortal/Clients/reducer";
import companyLogisticsIssues from "./CompanyPortal/LogisticsIssues/reducer";
import companyLoyalApplicants from "./CompanyPortal/LoyalApplicants/reducer";
import companyApplicantProfile from "./CompanyPortal/ApplicantProfile/reducer";
import companyEventTimesheet from "./CompanyPortal/EventTimesheet/reducer";
import companyEvaluations from "./CompanyPortal/Evaluations/reducer";
import companyNotifications from "./CompanyPortal/Notifications/reducer";
import clientNotifications from "./ClientPortal/Notifications/reducer";
import adminEventRequests from "./AdminEventRequests/reducer";
import userTags from "./UserTags/reducer";
import demoRequests from "./DemoRequests/reducer";
import payroll from "./Payroll/reducer";
import adminDashboard from "./AdminDashboard/reducer";
import companyDashboard from "./CompanyPortal/Dashboard/reducer";
import activityLogs from "./ActivityLogs/reducer";
import companyActivityLogs from "./CompanyPortal/ActivityLogs/reducer";

export default combineReducers({
  rolesReducer,
  heatmapReducer,
  surveyReducer,
  locale,
  snackbar,
  loader,
  navigation,
  auth,
  lookups,
  events,
  routing,
  requests,
  employees,
  clientsReducer,
  applicants,
  promotionRequests,
  companiesRegistration,
  companiesList,
  profileEditRequests,
  notifications,
  timesheet,
  applicantsTimeSheetRequest,
  trainingWorkingSlots,
  evaluations,
  locations,
  note,
  _filters,
  reason,
  report,
  joiningRequest,
  applicantTabs,
  persistEmployee,
  persistTimeSheet,
  persistTimeSheetEvent,
  role,
  persistReport,
  applicantReports,
  applicantTabExportSheet,
  companyEditRequest,
  companyMyCompany,
  companyEventRequests,
  companyRoles,
  companyEmployees,
  companyClients,
  companyLogisticsIssues,
  companyLoyalApplicants,
  companyApplicantProfile,
  companyEventTimesheet,
  companyEvaluations,
  companyNotifications,
  clientNotifications,
  adminEventRequests,
  userTags,
  demoRequests,
  payroll,
  adminDashboard,
  companyDashboard,
  activityLogs,
  companyActivityLogs,
});
